import {rpc} from './session';

export async function getUploadToken() {
    return await rpc.request('com.rnis.storage.action.token.unauth');
}

export async function uploadFile(url, data) {
    const response = await fetch(url, {
        method: 'POST',
        body: data
    });
    const json = await response.json();
    return json.payload;
}


// WEBPACK FOOTER //
// ./src/helpers/api/storage.js